export default {
  brand: {
    name: '思棟株式会社',
    description: '思棟株式会社は、革新的な技術を通じて企業のデジタルトランスフォーメーションを支援し、インテリジェントな未来を共に創造することに取り組んでいます。'
  },
  quickLinks: {
    title: 'クイックリンク',
    home: 'ホーム',
    about: '会社概要',
    coreService: 'コアサービス',
    industrySolutions: '業界ソリューション',
    caseStudies: '事例紹介',
    resourceCenter: 'リソースセンター',
    customerSupport: 'カスタマーサポート',
    contact: 'お問い合わせ'
  },
  solutions: {
    title: '業界ソリューション',
    finance: '金融業界',
    ticketAI: 'チケットAIアシスタント',
    manufacturing: '製造業',
    healthcare: '医療・ヘルスケア',
    government: '政府・公共サービス'
  },
  contactInfo: {
    title: '連絡先情報',
    address: '中国上海市静安区西藏北路199号 光明地产大厦1003-1室'
  },
  copyright: '© 2023 思棟株式会社. All rights reserved.'
}
